var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReInviteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Re-invite_18px",
    transform: "translate(-1166 -476)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_813",
    "data-name": "Rectangle 813",
    width: 18,
    height: 18,
    transform: "translate(1166 476)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2493",
    "data-name": "Group 2493",
    transform: "translate(61.226 -148.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail-open-outline",
    transform: "translate(1105.625 626.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M63.418,86.312l-6.845-3.378a.962.962,0,0,0-.852,0l-6.845,3.378a1.567,1.567,0,0,0-.877,1.4v7.232a1.577,1.577,0,0,0,1.587,1.567H62.71A1.577,1.577,0,0,0,64.3,94.945V87.714A1.567,1.567,0,0,0,63.418,86.312Z",
    transform: "translate(-48 -82.835)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M73.387,194.2l-4.738,3.3a.963.963,0,0,1-1.08,0l-4.739-3.3m7.332,2.393-4-.066",
    transform: "translate(-59.96 -187.377)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "add-outline",
    d: "M113.823,112v3.646m1.823-1.823H112",
    transform: "translate(999.951 518.004)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReInviteIcon);
export default __webpack_public_path__ + "static/media/re-invite-icon.b2988e06914c551cf75e974a2d42907e.svg";
export { ForwardRef as ReactComponent };